import { ENDPOINTS } from 'src/constants/endpoints'

import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'
import type { IMemberInsightCategoriesResponseDTO } from 'src/app/home/pages/member-insights/domain/contracts/member-insights'
import { http } from 'src/interfaces/http'

export const getMemberInsightCategories =
  async (): Promise<IMemberInsightCategoriesResponseDTO> => {
    const { data } = await http.get<IMemberInsightCategoriesResponseDTO>(
      ENDPOINTS.hanwha.memberInsightCategories,
      { params: { org_id: HANWHA_ORG_ID } },
    )
    return data
  }
